export default __webpack_public_path__ + "static/media/closet5-before1-480w.e46b2be8.avif";